<template>
  <div>
    <div class="d-flex justify-center pb-4">
      <v-img src="../assets/logo_logowanie.png" max-width="150"></v-img>
    </div>
    <v-card :width=this.width class="rounded-card">
      <v-card-title>
        <h1>Przypomnienie hasła</h1>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="!password">
        <h3>Podaj proszę adres e-mail którego używasz do logowania, żebyśmy mogli Ci wysłać nowe hasło.</h3>
        <v-form @submit.prevent="submit">
          <v-text-field
                  v-model="email"
                  :error-messages="emailErrors"
                  required
                  @blur="$v.email.$touch()"
                  label="Adres e-mail"
                  prepend-icon="account_circle"
          />
        </v-form>
      </v-card-text>
      <v-card-text v-else class="d-flex justify-center">
        <div class="green--text text-center">
          <v-icon x-large class="green--text pb-2">check_circle_outline</v-icon>
          <h3>Świetnie, udało się!</h3>
          <h5>W ciągu najbliższych kilku minut, otrzymasz e-mail wraz z nowym hasłem</h5>
        </div>
      </v-card-text>
      <v-alert v-if="this.error" class="ma-4" dense outlined type="error">Podany adres e-mail nie widnieje w naszej bazie danych. Sprawdź proszę poprawność. Jeśli masz pytania, zadzwoń: +48 733 462 462</v-alert>
      <v-card-actions class="d-flex pa-2 justify-end">
        <v-btn v-if="!password" rounded :loading="loading" @click="send" color="secondary" class="text-right mr-2">Potwierdzam</v-btn>
        <v-btn v-else rounded :loading="loading" to="/" color="primary" class="text-right mr-2">Przejdź do logowania</v-btn>
      </v-card-actions>
      <v-divider class="mt-2"></v-divider>
      <p v-if="!password" class="pa-4"><v-icon small left>arrow_back</v-icon><router-link to="/">Powrót do logowania</router-link></p>
      <p v-else class="pa-4"></p>
    </v-card>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    mixins: [validationMixin],

    validations: {
      email: { required, email }
    },
    name: "Login",
    data () {
      return {
        email: '',
        password: '',
        error: false,
        loader: null,
        loading: false
      }
    },
    methods: {
      ...mapActions({
        resetPassword: 'users/resetPassword'
      }),
      send () {
        this.$v.$touch()
        if (!this.$v.email.$invalid) {
          this.loader = 'loading'
          this.loading = true
          this.resetPassword({email: this.email}).then(response => {
            this.$log.info('Email with password was sent ', response)
            this.error = false
            this.loading = false
            this.password = true
          }, error => {
            this.error = true
            this.loading = false
            this.$log.error('Login error', error)
          })
        }
      }
    },
    computed: {
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Podany adres e-mail jest niepoprawny')
        !this.$v.email.required && errors.push('Podanie e-maila jest wymagane')
        return errors
      },
      width () {
        return this.$vuetify.breakpoint.xsOnly ? "350" : "450"
      }
    }
  }
</script>

<style>
  .rounded-card {
      border-radius: 25px !important;
  }
  .error-message {
    font-weight: bold;
    text-decoration: underline;
    color: var(--v-error-base) !important;
  }
</style>
